<py-badge class="position-relative" [isNotification]="true" type="warning" [static]="true">
  {{ numberOfEntries }}
</py-badge>
